import { Text } from '@chakra-ui/react';
import React from 'react';

import { DeliverableActionKeyGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { deliverableStatusLabelDEPRECATED } from './constants';
import { ActionConfig } from './types';
import { Icon } from '~/packages/common-frontend/components/icons';
import {
  getDeliverablesPayloadWithAssert,
  getInsertedDeliverableStatusPayloadV1WithAssert,
  getSubmittedDeliverableSubmissionPayloadV1WithAssert,
  getUpdatedDeliverableStatusPayloadV1WithAssert,
} from '~/packages/common-frontend/utils';

// Exports
export const deliverables: Record<DeliverableActionKeyGQLType, ActionConfig> = {
  insertDeliverableItem: {
    Component: function InsertDeliverableItemComponent({ event }) {
      const { actorName, targetName } = event;
      const payload = getDeliverablesPayloadWithAssert(event);
      const {
        deliverableItem: { creditFacilityName },
      } = payload;
      return (
        <Text>
          <strong>{actorName}</strong>
          {` surfaced a deliverable: `}
          <strong>{targetName}</strong>
          {` for `}
          <strong>{creditFacilityName}</strong>
        </Text>
      );
    },
    icon: <Icon icon="clock" />,
  },
  updateDeliverableItemStatus: {
    Component: function InsertDeliverableItemComponent({ event }) {
      const { actorName, targetName } = event;
      const payload = getDeliverablesPayloadWithAssert(event);
      const {
        deliverableItem: { creditFacilityName, status },
      } = payload;
      return (
        <Text>
          <strong>{actorName}</strong>
          {` updated `}
          <strong>{targetName}</strong>
          {` to `}
          <strong>
            {deliverableStatusLabelDEPRECATED[status].label.toLocaleLowerCase()}
          </strong>
          {` for `}
          <strong>{creditFacilityName}</strong>
        </Text>
      );
    },
    icon: <Icon icon="pen-to-square" />,
  },
  // deliverables v3 events
  insertedDeliverable: {
    Component: function InsertedDeliverableItemComponent({ event }) {
      const { actorName, targetName } = event;
      const payload = getInsertedDeliverableStatusPayloadV1WithAssert(event);
      const {
        deliverable: { creditFacilityName },
      } = payload;
      return (
        <Text>
          <strong>{actorName}</strong>
          {` surfaced a deliverable: `}
          <strong>{targetName}</strong>
          {` for `}
          <strong>{creditFacilityName}</strong>
        </Text>
      );
    },
    icon: <Icon icon="clock" />,
  },
  updatedDeliverableStatus: {
    Component: function UpdatedDeliverableStatusComponent({ event }) {
      const { actorName, targetName } = event;
      const payload = getUpdatedDeliverableStatusPayloadV1WithAssert(event);
      const {
        deliverable: { creditFacilityName, status },
      } = payload;
      return (
        <Text>
          <strong>{actorName}</strong>
          {` updated `}
          <strong>{targetName}</strong>
          {` to `}
          <strong>{status.toLocaleLowerCase()}</strong>
          {` for `}
          <strong>{creditFacilityName}</strong>
        </Text>
      );
    },
    icon: <Icon icon="pen-to-square" />,
  },
  submittedDeliverableSubmission: {
    Component: function SubmittedDeliverableSubmission({ event }) {
      const { actorName, targetName } = event;
      const payload = getSubmittedDeliverableSubmissionPayloadV1WithAssert(
        event,
      );
      const {
        deliverable: { creditFacilityName },
      } = payload;
      return (
        <Text>
          <strong>{actorName}</strong>
          {` submitted `}
          <strong>{targetName}</strong>
          {` for `}
          <strong>{creditFacilityName}</strong>
        </Text>
      );
    },
    icon: <Icon icon="paper-plane" />,
  },
};
